import { assign } from 'lodash';
import API from '../api';
import * as actions from '../constants';
import { uploadImage } from './app';
import generateActions from './baseAction';

const {
  showError,
  clearErrors,
  getAccessories,
  getAccessory,
  removeAccessory,
} = generateActions('accessory', 'accessories', 'accessories', 'accessory', 'accessories');

/**
 * Action to mark an add accessory request as sent
 * @param {Object} fields
 */
const requestAddAccessory = (fields): any => ({
  fields,
  type: actions.REQUEST_ADD_ACCESSORY,
});

/**
 * Action to mark an add accessory request as received
 * @param {String|Boolean} error
 * @param {Object} data
 */
const receiveAddAccessory = (error, data): any => ({
  error,
  data,
  type: actions.RECEIVE_ADD_ACCESSORY,
});

/**
 * Add an accessory
 * @param {Object} fields
 * @return {Promise}
 */
const addAccessory = (fields): any => (
  (dispatch) => {
    dispatch(requestAddAccessory(fields));
    return new Promise((resolve, reject) => {
      dispatch(uploadImage(fields.image))
      .then((image) => {
        API.request('/accessories', 'POST', assign({}, fields, { image }))
        .then(response => response.json())
        .then((response) => {
          dispatch(receiveAddAccessory(response.error, response.data));
          resolve(response);
        });
      })
      .catch(() => {
        dispatch(receiveAddAccessory('Failed to upload image', {}));
        reject();
      });
    });
  }
);

/**
 * Action to mark an update accessory request as sent
 * @param {Number} id
 */
const requestUpdateAccessory = (id): any => ({
  id,
  type: actions.REQUEST_UPDATE_ACCESSORY,
});

/**
 * Action to mark an update accessory request as received
 * @param {Number} id
 * @param {String|Boolean} error
 * @param {Object} data
 */
const receiveUpdateAccessory = (id, error, data): any => ({
  id,
  error,
  data,
  type: actions.RECEIVE_UPDATE_ACCESSORY,
});

/**
 * Update a accessory
 * @param {Number} id
 * @param {Object} fields
 * @return {Promise}
 */
const updateAccessory = (id, fields): any => (
  (dispatch) => {
    dispatch(requestUpdateAccessory(id));

    // Attempt to upload the image if one specified
    return new Promise((resolve, reject) => {
      if (!fields.image) {
        resolve(fields);
        return;
      }
      dispatch(uploadImage(fields.image)).then((image) => {
        resolve(assign({}, fields, { image }));
      }).catch((err) => {
        dispatch(receiveUpdateAccessory(id, err, {}));
        reject(err);
      });

    // Update the fields
    }).then((fieldsToUpdate: any) => (
      API.request(`/accessories/${id}`, 'POST', fieldsToUpdate)
      .then(response => response.json())
      .then((response) => {
        dispatch(receiveUpdateAccessory(id, response.error, response.data));
        return response;
      })
    ));
  }
);

export {
  showError,
  clearErrors,
  getAccessories,
  getAccessory,
  addAccessory,
  updateAccessory,
  removeAccessory,
};
